import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://c07445beeb316bd2f2900b4b9898f178@o526716.ingest.us.sentry.io/4509388044959744",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});